import type { FieldConfig } from '../common/ui/types.tsx';
import { issuesMockData } from './issue-mock-data.tsx';
import type { State } from './types.tsx';

export const initialState: State = {
	isLoading: false,
	issuesInCurrentPage: [],
	selectedIssues: {},
	numberOfSelectedIssues: 0,
	currentPage: 1,
	totalPages: 2,
	issuesMockData,
	filters: {},
	projectId: '',
	searchBy: '',
	issueDetails: {},
	archivesIssueDataPresent: true,
	// this state has to be true intially to fetch intial load data
	refetchArchivesIssuesData: true,
};

export const filterFields: FieldConfig = {
	issueType: { label: 'ISSUE TYPE', options: [], type: 'AvatarSelectFilter' },
	reporter: {
		label: 'REPORTER',
		options: [],
		type: 'AvatarAsyncSelectFilter',
		defaultOptions: [],
		cacheOptions: true,
	},
	archivedDate: { label: 'ARCHIVED DATE', type: 'DateFilter' },
	archivedBy: {
		label: 'ARCHIVED BY',
		options: [],
		type: 'AvatarAsyncSelectFilter',
		defaultOptions: [],
		cacheOptions: true,
	},
};
